"use strict";

var UniFiChildCategorySlug = /* @__PURE__ */(UniFiChildCategorySlug2 => {
  UniFiChildCategorySlug2["CloudGatewaysEnterpriseScale"] = "cloud-gateways-enterprise-scale";
  UniFiChildCategorySlug2["CloudGatewaysLargeScale"] = "cloud-gateways-large-scale";
  UniFiChildCategorySlug2["CloudGatewaysCompact"] = "cloud-gateways-compact";
  UniFiChildCategorySlug2["CloudGatewaysWifiIntegrated"] = "cloud-gateways-wifi-integrated";
  UniFiChildCategorySlug2["WiFiEnterprise"] = "wifi-enterprise";
  UniFiChildCategorySlug2["WiFiFlagship"] = "wifi-flagship";
  UniFiChildCategorySlug2["WiFiWall"] = "wifi-wall";
  UniFiChildCategorySlug2["WiFiOutdoor"] = "wifi-outdoor";
  UniFiChildCategorySlug2["WiFiMegaCapacity"] = "wifi-mega-capacity";
  UniFiChildCategorySlug2["WiFiBridging"] = "wifi-bridging";
  UniFiChildCategorySlug2["SwitchingAggregation"] = "switching-aggregation";
  UniFiChildCategorySlug2["SwitchingEnterprise"] = "switching-enterprise";
  UniFiChildCategorySlug2["SwitchingProfessionalMaxXg"] = "switching-professional-max-xg";
  UniFiChildCategorySlug2["SwitchingProfessional"] = "switching-professional";
  UniFiChildCategorySlug2["SwitchingStandard"] = "switching-standard";
  UniFiChildCategorySlug2["SwitchingWan"] = "switching-wan";
  UniFiChildCategorySlug2["SwitchingUtility"] = "switching-utility";
  UniFiChildCategorySlug2["AdvancedHostingOther"] = "advanced-hosting-other";
  UniFiChildCategorySlug2["CamerasNVR"] = "cameras-nvr";
  UniFiChildCategorySlug2["CamerasBullet"] = "cameras-bullet";
  UniFiChildCategorySlug2["CamerasDomeTurret"] = "cameras-dome-turret";
  UniFiChildCategorySlug2["CamerasCompact"] = "cameras-compact";
  UniFiChildCategorySlug2["CamerasTheta"] = "cameras-theta";
  UniFiChildCategorySlug2["CamerasPTZ"] = "cameras-ptz";
  UniFiChildCategorySlug2["CamerasDoorbells"] = "cameras-doorbells";
  UniFiChildCategorySlug2["CamerasSpecialDevices"] = "cameras-special-devices";
  UniFiChildCategorySlug2["CamerasAccessories"] = "camera-accessories";
  UniFiChildCategorySlug2["DoorAccessReaders"] = "door-access-readers";
  UniFiChildCategorySlug2["DoorAccessNVRs"] = "door-access-nvrs";
  UniFiChildCategorySlug2["DoorAccessHub"] = "door-access-hub";
  UniFiChildCategorySlug2["DoorAccessStarterKit"] = "door-access-starter-kit";
  UniFiChildCategorySlug2["DoorAccessIntercoms"] = "door-access-intercoms";
  UniFiChildCategorySlug2["DoorAccessAccessories"] = "door-access-accessories";
  UniFiChildCategorySlug2["ManagedVoIP"] = "managed-voip";
  UniFiChildCategorySlug2["MobileRouting"] = "mobile-routing";
  UniFiChildCategorySlug2["EVCharging"] = "ev-charging";
  UniFiChildCategorySlug2["DigitalSignage"] = "digital-signage";
  UniFiChildCategorySlug2["PremiumAudio"] = "premium-audio";
  UniFiChildCategorySlug2["InternetSolutions"] = "internet-solutions";
  UniFiChildCategorySlug2["IntegrationsPowerTech"] = "integrations-power-tech";
  UniFiChildCategorySlug2["AccessoriesCablesDACS"] = "accessories-cables-dacs";
  UniFiChildCategorySlug2["AccessoriesModulesFiber"] = "accessories-modules-fiber";
  UniFiChildCategorySlug2["AccessoriesSFPLiberationDay"] = "accessories-sfp-liberation-day";
  UniFiChildCategorySlug2["AccessoriesStorage"] = "accessories-storage";
  UniFiChildCategorySlug2["AccessoriesRackMount"] = "accessories-rack-mount";
  UniFiChildCategorySlug2["AccessoriesInstallations"] = "accessories-installations";
  UniFiChildCategorySlug2["AccessoriesPoEPower"] = "accessories-poe-power";
  UniFiChildCategorySlug2["AccessoriesAccessPoint"] = "accessories-access-point";
  UniFiChildCategorySlug2["AccessoriesCamera"] = "accessories-camera";
  UniFiChildCategorySlug2["AccessoriesDoorAccess"] = "accessories-door-access";
  UniFiChildCategorySlug2["AccessoriesApparel"] = "accessories-apparel";
  UniFiChildCategorySlug2["NetworkStorage"] = "network-storage";
  return UniFiChildCategorySlug2;
})(UniFiChildCategorySlug || {});
var UniFiCategoryId = /* @__PURE__ */(UniFiCategoryId2 => {
  UniFiCategoryId2["WhatsNew"] = "whats-new";
  UniFiCategoryId2["CloudGateways"] = "cloud-gateways";
  UniFiCategoryId2["WiFi"] = "wifi";
  UniFiCategoryId2["Switching"] = "switching";
  UniFiCategoryId2["AdvancedHosting"] = "advanced-hosting";
  UniFiCategoryId2["CamerasNVRs"] = "cameras-nvrs";
  UniFiCategoryId2["DoorAccess"] = "door-access";
  UniFiCategoryId2["Integrations"] = "integrations";
  UniFiCategoryId2["Accessories"] = "accessories";
  return UniFiCategoryId2;
})(UniFiCategoryId || {});
var UniFiCategorySlug = /* @__PURE__ */(UniFiCategorySlug2 => {
  UniFiCategorySlug2["CloudGateways"] = "all-cloud-gateways";
  UniFiCategorySlug2["WiFi"] = "all-wifi";
  UniFiCategorySlug2["Switching"] = "all-switching";
  UniFiCategorySlug2["AdvancedHosting"] = "all-advanced-hosting";
  UniFiCategorySlug2["CamerasNVRs"] = "all-cameras-nvrs";
  UniFiCategorySlug2["DoorAccess"] = "all-door-access";
  UniFiCategorySlug2["Integrations"] = "all-integrations";
  UniFiCategorySlug2["Accessories"] = "accessories-cables-dacs" /* AccessoriesCablesDACS */;
  return UniFiCategorySlug2;
})(UniFiCategorySlug || {});
export { UniFiCategoryId, UniFiCategorySlug, UniFiChildCategorySlug };
//# sourceMappingURL=unifi.mjs.map
